module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Surya Das\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Lama Surya Das is one of the foremost American Buddhist teachers and scholars and is known affectionately to His Holiness the Dalai Lama as the \"American Lama.\" Surya Das is the author of the bestselling books "), _c('I', [_vm._v("Awakening the Buddha Within")]), _vm._v(" and "), _c('I', [_vm._v("Buddha Is as Buddha Does")]), _vm._v(", founder and spiritual director of the Dzogchen Center, and founder of the Western Buddhist Teachers Network. A sought-after speaker who teaches, lectures, and conducts retreats around the world, he lives in Concord, Massachusetts.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/U7PXjP/tc-custom/9780062079480.jpg?1718044221142",
      "alt": "This image is the cover for the book Buddha Standard Time"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Buddha Standard Time\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"Awealth of inspiration and practical tips for enjoying the Kingdom of God, thePure Land of the Buddha, now.\" —Thich Nhat Hanh, bestselling author of "), _c('i', [_vm._v("Peace Is EveryStep")])]), _c('p', [_vm._v("\"Fornewcomers to Buddhism (and non-Buddhists interested in universal wisdom!) and‘old hands’ at practice . . . [Das] promises nothing less than a liberatedlife, freed from angst over the tyranny of time, though the practice of lovingpresence.\" —Sylvia Boorstein, author of "), _c('i', [_vm._v("Happiness Is An Inside Job")])]), _c('p', [_vm._v("Internationallyrenowned meditation scholar Lama Surya Das delivers a penetrating and practicalguide to discovering the power of living fully in the now. In the tradition ofthe Dalai Lama’s "), _c('i', [_vm._v("The Art of Happiness ")]), _vm._v("and Noah Levine’s "), _c('i', [_vm._v("Heartof the Revolution")]), _vm._v(", "), _c('i', [_vm._v("Buddha Standard Time")]), _vm._v(" is a roadmap to discoveringyour own inner kingdom of awareness, patience, and love. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0